import { styled, Typography } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 64px;

  @media (max-width: 1023px) {
    margin-top: 0px;
    padding: 88px 16px 96px 16px;
  }
`;

export const PostSubmissionNote = styled(Typography)`
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: ${({ theme }) => theme.palette.primary.p080};
  white-space: break-spaces;
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const ContentW = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
`;
